import axios from "axios";
import Cookies from "js-cookie";
import config from "../../config";

// Crear instancia de Axios con baseURL y JWT
const api = axios.create({
  baseURL: config.baseUrl,
});

api.interceptors.request.use(
  (cfg) => {
    const token = Cookies.get("token");
    if (token) cfg.headers["Authorization"] = `Bearer ${token}`;
    return cfg;
  },
  (error) => Promise.reject(error)
);

// Endpoints
const ENDPOINT = "/api/entregas/ordenes-servicios";
const ENDPOINTDETALLE = "/api/entregas/ordenes-servicios-detalles";
const ENDPOINT_PRODUCTS = "/api/entregas/po-productos";
const ENDPOINT_STOCK = "/api/entregas/po-stock";
const ENDPOINT_SERIALES = "/api/entregas/po-seriales";
const ENDPOINT_INFORME_ENTREGAS_PO =
  "/api/entregas/informe-entregas-producto-po";

/**
 * Obtener todas las órdenes de servicio
 */
export const getOrdenesServicios = async () => {
  try {
    const response = await api.get(ENDPOINT);

    return {
      status: response.status,
      data: response.data.data || response.data.ordenesServicios || [],
    };
  } catch (error) {
    console.error("Error fetching ordenes:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message || "Error fetching órdenes de servicio",
    };
  }
};

export const getStockOrdenesServicios = async () => {
  try {
    const response = await api.get(ENDPOINT_STOCK);

    return {
      status: response.status,
      data: response.data.data || response.data.ordenesServicios || [],
    };
  } catch (error) {
    console.error("Error fetching ordenes:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message || "Error fetching órdenes de servicio",
    };
  }
};

export const getOrdenesServiciosDetalle = async (oidOrden) => {
  try {
    // si viene oidOrden lo añadimos a la URL
    const url = oidOrden
      ? `${ENDPOINTDETALLE}?oidOrden=${encodeURIComponent(oidOrden)}`
      : ENDPOINTDETALLE;

    const response = await api.get(url);

    return {
      status: response.status,
      data: response.data.data ?? response.data.ordenesServicios ?? [],
      message: response.data.message,
    };
  } catch (error) {
    console.error("Error fetching ordenes detalle:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message ||
        "Error fetching órdenes de servicio detalle",
    };
  }
};

/**
 * Crear nueva orden de servicio
 */
export const createOrdenServicio = async (payload) => {
  try {
    const response = await api.post(ENDPOINT, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return {
      status: response.status,
      data: response.data.data || {
        insertedId: response.data.data?.insertedId,
      },
      message: response.data.message,
    };
  } catch (error) {
    console.error("Error creating orden:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message || "Error creating orden de servicio",
    };
  }
};
/**
 * Actualizar orden de servicio existente
 */
export const updateOrdenServicio = async (oid, payload) => {
  // Si payload es FormData, indicamos el header. Si no, dejamos que axios use JSON.
  const config = {};
  if (payload instanceof FormData) {
    config.headers = { "Content-Type": "multipart/form-data" };
  }

  try {
    const response = await api.put(`${ENDPOINT}/${oid}`, payload, config);
    return {
      status: response.status,
      message: response.data.message || "Orden actualizada correctamente",
    };
  } catch (error) {
    console.error("Error updating orden:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message || "Error updating orden de servicio",
    };
  }
};

/**
 * Eliminar una orden de servicio
 */
export const deleteOrdenServicio = async (oid) => {
  try {
    const response = await api.delete(`${ENDPOINT}/${oid}`);
    return {
      status: response.status,
      message: response.data.message || "Orden eliminada correctamente",
    };
  } catch (error) {
    console.error("Error deleting orden:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message || "Error deleting orden de servicio",
    };
  }
};

export const getPoProductos = async () => {
  try {
    const response = await api.get(`${ENDPOINT_PRODUCTS}`);
    return {
      status: response.status,
      data: response.data.data || [],
    };
  } catch (error) {
    console.error(`Error fetching productos PO:`, error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message || "Error fetching productos de orden",
    };
  }
};

export const registrarProductoOrden = async (payload, oidOrden) => {
  if (!oidOrden) {
    console.error("OID Orden is required to register product in order");
    return {
      status: 400,
      message: "OID Orden is required",
    };
  }

  try {
    let response;

    if (Array.isArray(payload)) {
      // Varios productos
      response = await api.post("/api/entregas/po-productos-registro-detalle", {
        oidPo: oidOrden,
        productos: payload,
      });
    } else {
      // Un solo producto
      response = await api.post(
        `/api/entregas/po-productos-detalle/${oidOrden}`,
        payload
      );
    }

    return {
      status: response.status,
      data: response.data?.oidsInsertados || null, // 👈 aquí el cambio
      message: response.data?.message || "Producto(s) registrado(s) con éxito",
    };
  } catch (error) {
    console.error("Error registering product(s):", error);
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || "Error registrando producto(s)",
    };
  }
};

export const actualizarProductoOrden = async (payload, oidOrden) => {
  if (!oidOrden) {
    console.error("OID Orden is required to register product in order");
    return {
      status: 400,
      message: "OID Orden is required",
    };
  }

  try {
    let response;

    if (Array.isArray(payload)) {
      // Varios productos
      response = await api.post(
        "/api/entregas/po-productos-actualizar-detalle",
        {
          oidPo: oidOrden,
          productos: payload,
        }
      );
    } else {
      // Un solo producto
      response = await api.post(
        `/api/entregas/po-productos-actualizar/${oidOrden}`,
        payload
      );
    }

    return {
      status: response.status,
      data: response.data?.oidsInsertados || null, // 👈 aquí el cambio
      message: response.data?.message || "Producto(s) registrado(s) con éxito",
    };
  } catch (error) {
    console.error("Error registering product(s):", error);
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || "Error registrando producto(s)",
    };
  }
};

export const eliminarProductoOrden = async (oidProducto, userName) => {
  if (!oidProducto || !userName) {
    console.error("OID Producto and userName are required");
    return {
      status: 400,
      message: "OID Producto and userName are required",
    };
  }

  try {
    const response = await api.delete(
      `/api/entregas/po-productos-registro-detalle/${oidProducto}`,
      {
        data: { userName }, // ✅ el body del DELETE
      }
    );
    return {
      status: response.status,
      message: response.data?.message || "Producto eliminado correctamente",
    };
  } catch (error) {
    console.error("Error deleting product:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message || "Error deleting product from order",
    };
  }
};

export const leerPDFOrden = async (file) => {
  try {
    const formData = new FormData();
    formData.append("pdf", file);

    const response = await api.post("/api/entregas/leer-pdf", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error leyendo PDF:", error);
    return {
      status: error.response?.status || 500,
      message: error.response?.data?.message || "Error procesando PDF",
    };
  }
};

//SERIALES
/**
 * Obtiene seriales de productos de orden de compra.
 *
 * @param {number|string} [oidProductoPO] — (opcional) ID del producto en la PO.
 *   Si se pasa, se obtienen sólo los seriales de ese producto.
 *   Si no, se obtienen todos los seriales.
 * @returns {Promise<{ status: number, data?: any[], message?: string }>}
 */
export const getSerialesProducto = async (oidProductoPO) => {
  // construye la URL: con o sin parámetro
  const url = oidProductoPO
    ? `${ENDPOINT_SERIALES}/${oidProductoPO}`
    : ENDPOINT_SERIALES;

  try {
    const response = await api.get(url);
    return {
      status: response.status,
      data: Array.isArray(response.data?.data) ? response.data.data : [],
    };
  } catch (error) {
    console.error("Error fetching seriales de producto PO:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message ||
        "Error fetching seriales de producto PO",
    };
  }
};

/**
 * Registra (crea o actualiza) los seriales de un producto de orden de compra.
 *
 * @param {number|string} oidProductoPO — ID del producto en la PO.
 * @param {Array<{ serial: string, nota?: string }>} seriales — Lista de seriales a guardar.
 * @returns {Promise<{ status: number, data?: any, message?: string }>}
 */
// servicesOrdenesCompra.js
export const registrarSerialesProducto = async (oidProductoPO, seriales) => {
  // valida rápido el parámetro
  const oid = Number(oidProductoPO);
  if (!Number.isFinite(oid) || oid <= 0) {
    throw new Error("oidProductoPO inválido");
  }

  const url = `${ENDPOINT_SERIALES}/${oid}`;

  // normaliza payload (trim) y respeta el contrato { seriales: [...] }
  const payload = {
    seriales: (seriales || []).map((s) => ({
      serial: String(s?.serial ?? "").trim(),
      nota: s?.nota ?? "",
    })),
  };

  try {
    const response = await api.post(
      url,
      payload /* , { withCredentials: true } */
    );
    // devuelve el response de axios tal cual (o response.data si prefieres)
    return response; // { status, data, ... }
  } catch (error) {
    // ⚠️ IMPORTANTE: NO devolver un objeto propio; relanzar para que el caller vea error.response
    // Opcional: console para debug
    console.error("Error registrando seriales de producto PO:", error);
    throw error; // ← deja que el componente maneje status, code, message
  }
};

//Service informe de seguimiento de entregas vs productos PO
export const getInformeEntregasByProductoPO = async () => {
  try {
    const response = await api.get(`${ENDPOINT_INFORME_ENTREGAS_PO}`);
    return {
      status: response.status,
      data: response.data.data || [], // asumiendo que tu backend envía { data: [...] }
    };
  } catch (error) {
    console.error("Error fetching informe entregas PO:", error);
    return {
      status: error.response?.status || 500,
      message:
        error.response?.data?.message ||
        "Error al obtener informe de entregas por PO",
    };
  }
};
